/* ==========================================================================
   ESTA VIDA LOCA — product page
   Gallery thumbnails and variant pills. No framework, no dependencies.
   ========================================================================== */

(function () {
  'use strict';

  /* ----------------------------------------------------------------------
     Gallery — thumbnails swap the main image.
     Active thumbnail carries a Blood hairline; the rest sit at 70% opacity.
     ---------------------------------------------------------------------- */

  var gallery = document.querySelector('[data-evl-gallery]');

  if (gallery) {
    var slides = gallery.querySelectorAll('[data-evl-gallery-slide]');
    var thumbs = gallery.querySelectorAll('[data-evl-gallery-thumb]');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.getAttribute('data-evl-gallery-thumb');

        slides.forEach(function (slide) {
          slide.hidden = slide.getAttribute('data-evl-gallery-slide') !== index;
        });

        thumbs.forEach(function (other) {
          var isActive = other === thumb;
          other.classList.toggle('evl-thumb--active', isActive);
          if (isActive) {
            other.setAttribute('aria-current', 'true');
          } else {
            other.removeAttribute('aria-current');
          }
        });
      });
    });
  }

  /* ----------------------------------------------------------------------
     Variants — pills drive the hidden id, the price, and the button state.
     ---------------------------------------------------------------------- */

  var variantData = document.querySelector('[data-evl-variants]');
  var idInput = document.querySelector('[data-evl-variant-id]');
  if (!variantData || !idInput) return;

  var variants;
  try {
    variants = JSON.parse(variantData.textContent);
  } catch (e) {
    return;
  }
  if (!Array.isArray(variants) || !variants.length) return;

  var inputs = document.querySelectorAll('[data-evl-option-index]');
  var priceEl = document.querySelector('[data-evl-price]');
  var noteEl = document.querySelector('[data-evl-price-note]');
  var addBtn = document.querySelector('[data-evl-add]');
  var addLabel = document.querySelector('[data-evl-add-label]');

  // Per-format notes, keyed by variant id. Present on the Galería print page,
  // absent on the book — metafields do not travel in product.variants | json,
  // so they ride in their own map.
  var formatNoteEl = document.querySelector('[data-evl-format-note]');
  var formatNotes = {};
  var notesData = document.querySelector('[data-evl-variant-notes]');
  if (notesData) {
    try {
      formatNotes = JSON.parse(notesData.textContent) || {};
    } catch (e) {
      formatNotes = {};
    }
  }

  // Both labels come off the button as data attributes rather than being read
  // from the rendered text — a product that loads sold out would otherwise
  // capture "Agotado" as its add-to-cart label and never recover.
  var soldOutText = addBtn ? addBtn.getAttribute('data-sold-out-text') : '';
  var defaultLabel = addBtn ? addBtn.getAttribute('data-add-text') : '';

  // Shopify's money format for this shop, read off the rendered price so the
  // script never has to guess a currency or a separator convention.
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    if (!priceEl) return amount;

    var current = priceEl.textContent.trim();
    // Swap the digits, keep whatever symbol and spacing the shop already uses.
    return current.replace(/[\d.,]+/, amount);
  }

  function selectedOptions() {
    var chosen = [];
    inputs.forEach(function (input) {
      if (input.checked) {
        chosen[parseInt(input.getAttribute('data-evl-option-index'), 10)] = input.value;
      }
    });
    return chosen;
  }

  function findVariant(chosen) {
    return variants.find(function (variant) {
      return chosen.every(function (value, index) {
        return variant.options[index] === value;
      });
    });
  }

  function update() {
    var variant = findVariant(selectedOptions());

    if (!variant) {
      if (addBtn) {
        addBtn.disabled = true;
        if (addLabel) addLabel.textContent = soldOutText || defaultLabel;
      }
      return;
    }

    idInput.value = variant.id;

    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    // A digital variant ships nothing — it must never carry the print's
    // free-shipping line. requires_shipping comes off the variant itself.
    if (noteEl) {
      var note = variant.requires_shipping
        ? noteEl.getAttribute('data-note-shipped')
        : noteEl.getAttribute('data-note-digital');
      noteEl.textContent = note ? ' — ' + note : '';
    }

    // What this edition actually is. Numbered, open, and digital are three
    // different promises and must not inherit each other's copy.
    if (formatNoteEl) {
      formatNoteEl.textContent = formatNotes[variant.id] || '';
    }

    if (addBtn) {
      addBtn.disabled = !variant.available;
      if (addLabel) {
        addLabel.textContent = variant.available
          ? defaultLabel
          : soldOutText || addLabel.textContent;
      }
    }

    // Keep the URL honest so a shared link lands on the same edition.
    if (window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  inputs.forEach(function (input) {
    input.addEventListener('change', update);
  });
})();
